import { CopyValue, Help, type Copy as Words } from '@beyond-js/ui/react';

/**
 * A digest: the family's `CopyValue` (mono, cut in the middle and shown whole, Copy that says Copied, D104),
 * with what it means behind the shared help button. It sits in a package's card, never in a table cell, so
 * opening the help reflows nothing around it.
 */
export function Digest({ value, topic, explanation, labels }: { value?: string; topic: string; explanation: string; labels?: Words }) {
	if (!value) return <span className="text-ink-muted">—</span>;
	return (
		<span className="flex w-full min-w-0 items-center gap-1" data-digest={value}>
			<CopyValue value={value} label={topic} cut="end" />
			<Help topic={`${topic} ${value.slice(0, 12)}`} text={explanation} labels={labels} />
		</span>
	);
}
